import React from 'react'
import { Route, Redirect } from 'react-router'
import { Routes } from '..'

interface PrivateRouteProps {
  component: () => JSX.Element
  path: string
  exact?: boolean
}
/// This route checks for credentials
const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ...otherProps
}) => {
  const hasCredentials = !!localStorage.getItem('session_token')

  if (!hasCredentials) {
    return <Redirect to={Routes.LOGIN} />
  }

  return <Route {...otherProps} render={() => <Component />} />
}

export default React.memo(PrivateRoute)
